// @flow
import gql from 'graphql-tag';

export type AdSenseConfiguration = {
    query: string,
    queryLink: string,
    queryContext: string,
    channel: string,
    hl: string,
    pubId: string
};

export const fragments = {
    results: gql`
        fragment AdSenseResults on Results {
            searchTerm {
                name
                termId
            }
            adSenseConfiguration {
                query
                queryLink
                queryContext
                channel
                adtest
                hl
                pubId
            }
        }
    `
};
